export enum Icon {
  appointment = 'appointment',
  call = 'call',
  meeting = 'meeting',
  task = 'task',
  logo = 'impact_logo',
  offline = 'offline',
  syncUnsuccessfully = 'sync_unsuccessfully',
  disabledCart = 'disabled_cart',
  enabledCart = 'enabled_cart'
}
